module.exports = __webpack_public_path__ + "static/img/3.c0e1c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/index/vip-banner/3.jpg
// module id = GWQB
// module chunks = 0